import reducer from "./dialog";
import { actions, selectors } from "./dialog";

export default reducer;
export { actions, selectors };
